// extracted by mini-css-extract-plugin
export default {"default":"App_default__e2Fy1"};